<template>
  <div id="app">
    <header class="site-header" :class="{ compact: compact }">
      <div class="header-inner">
        <router-link to="/" class="logo-link" @click.native="menuOpen = false">
          <img class="logo-img" :src="baseUrl + 'img/logo2-white.png'" alt="雅澜瀚玥 · 整车软装" />
        </router-link>
        <button
          class="nav-toggle"
          :class="{ open: menuOpen }"
          aria-label="打开菜单"
          @click="menuOpen = !menuOpen">
          <span></span><span></span><span></span>
        </button>
        <nav class="nav" :class="{ open: menuOpen }">
          <router-link to="/" @click.native="menuOpen = false">首页</router-link>
          <router-link to="/brand" @click.native="menuOpen = false">品牌</router-link>
          <router-link to="/products" @click.native="menuOpen = false">产品</router-link>
          <router-link to="/banxin" @click.native="menuOpen = false">版型查询</router-link>
          <router-link to="/about" @click.native="menuOpen = false">企业</router-link>
        </nav>
      </div>
    </header>

    <router-view />

    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-brand">
          <img class="logo-img" :src="baseUrl + 'img/logo-white.png'" alt="雅澜瀚玥" />
          <p class="slogan">整车软装 · 欧式典范</p>
          <p>专注欧式汽车座套与整车软装定制</p>
        </div>
        <div class="footer-nav">
          <div>
            <h4>品牌</h4>
            <router-link to="/brand">品牌文化</router-link>
            <router-link to="/about">关于我们</router-link>
          </div>
          <div>
            <h4>产品</h4>
            <router-link to="/products">产品中心</router-link>
            <router-link to="/banxin">版型查询</router-link>
          </div>
        </div>
      </div>
      <p class="footer-copy">雅迪汽车装饰有限公司 · 雅澜瀚玥 YALAN HANYUE &nbsp;|&nbsp; Copyright © 2026 All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return { menuOpen: false, compact: false };
  },
  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.compact = window.scrollY > 40;
    }
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>
